import { SystemCheckSectionId } from "types/systemCheck"

export const SystemCheckSectionIds: Record<SystemCheckSectionId, SystemCheckSectionId> = {
  system_compatability: "system_compatability",
  io_devices: "io_devices",
  mobile_camera_pairing: "mobile_camera_pairing",
  screen_share_permission: "screen_share_permission",
  full_screen_mode: "full_screen_mode",
}
